// PopupContext.js
import { createContext, useContext, useState } from "react";

const PopupContext = createContext();

export const PopupProvider = ({ children }) => {
  const [popupData, setPopupData] = useState({
    show: false,
    title: "",
    message: "",
  });

  const showPopup = (title, message) => {
    setPopupData({ show: true, title, message });

    setTimeout(() => {
      setPopupData((prev) => ({ ...prev, show: false }));
    }, 4000);
  };

  const hidePopup = () => {
    setPopupData((prev) => ({ ...prev, show: false }));
  };

  return (
    <PopupContext.Provider value={{ ...popupData, showPopup, hidePopup }}>
      {children}
    </PopupContext.Provider>
  );
};

export const usePopup = () => useContext(PopupContext);
